import { Action } from 'redux';
// import { Customer } from 'src/types/model';

export interface ReceiptState {
  loading: boolean;
  // data: Customer[];
  data: any;
  error: string | null;
}

export const FETCH_RECEIPT_REQUEST = 'FETCH_RECEIPT_REQUEST';
export const FETCH_RECEIPT_SUCCESS = 'FETCH_RECEIPT_SUCCESS';
export const FETCH_RECEIPT_FAILURE = 'FETCH_RECEIPT_FAILURE';

export interface FetchReceiptRequestAction
  extends Action<typeof FETCH_RECEIPT_REQUEST> {}

export interface FetchReceiptSuccessAction
  extends Action<typeof FETCH_RECEIPT_SUCCESS> {
  // payload: Customer[];
  payload: any;
}

export interface FetchReceiptFailureAction
  extends Action<typeof FETCH_RECEIPT_FAILURE> {
  payload: string;
}

export type ReceiptActionType =
  | FetchReceiptRequestAction
  | FetchReceiptSuccessAction
  | FetchReceiptFailureAction;
